import { SortCalendarAscendingIcon } from './SortCalendarAscendingIcon';

/**
 * author: Austin Andrews
 * id 87CE4E85-7911-415C-89AB-133A2AB8BC57
 * name sort-calendar-ascending
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-calendar-ascending.svg
 * tags
 * - Text / Content / Format 
 * - Date / Time 
 */
export const SortDateAscendingIcon = SortCalendarAscendingIcon;
export default SortDateAscendingIcon